import {MetricType, TopLevelMetricType} from 'common/types/reports/bookmark';

/* eslint-disable import/no-cycle */
import {Entry, SelectorTypeDefinitions} from '../types';
import {helpers as FilterRowHelpers} from './filter/helpers';
import {helpers as FlowsRowHelpers} from './flows-entry/helpers';
import {helpers as FormulaRowHelpers} from './formula-entry/helpers';
import {helpers as GroupedRowHelpers} from './grouped-entry/helpers';
import {helpers as CohortGroupRowHelpers} from './inline-cohort/helpers';
import {helpers as NewMetricHelpers} from './new-metric-entry/helpers';
import {helpers as SavedMetricRowHelpers} from './metric-entry/metrics/saved-metric/helpers';
import {helpers as FunnelMetricRowHelpers} from './metric-entry/metrics/funnels/helpers';
import {helpers as RetentionMetricRowHelpers} from './metric-entry/metrics/retention/helpers';
import {helpers as SegmentRowHelpers} from './segment-entry/helpers';
import {helpers as SuperRowHelpers} from './super-entry/helpers';
import {helpers as MultiMetricsRowHelper} from './multi-metrics-entry/helpers';
import {EntryRowTypeHelpers, RowType} from './types';

/**
 * Finds the appropriate entry row handlers for a given entry type.
 */
export function getEntryRowHelpers(entryOrType: Entry | RowType): EntryRowTypeHelpers<any> {
  let rowType: RowType | undefined = undefined;
  if (typeof entryOrType === `string`) {
    rowType = entryOrType;
  } else if (
    `behavior` in entryOrType &&
    entryOrType.behavior?.type &&
    entryOrType?.type !== TopLevelMetricType.NewMetricEntry
  ) {
    /** maps to the old behavior-metric UI */
    rowType = entryOrType.behavior?.type;
  } else {
    rowType = entryOrType.type as RowType;
  }

  const ENTRY_ROW_HELPERS: Partial<Record<RowType, EntryRowTypeHelpers<any>>> = {
    [SelectorTypeDefinitions.Filter]: FilterRowHelpers,
    [SelectorTypeDefinitions.CohortGroup]: CohortGroupRowHelpers,
    [SelectorTypeDefinitions.GroupedEvent]: GroupedRowHelpers,
    [SelectorTypeDefinitions.Metrics]: MultiMetricsRowHelper,
    [MetricType.Formula]: FormulaRowHelpers,
    [TopLevelMetricType.NewFormulaEntry]: NewMetricHelpers,
    [TopLevelMetricType.NewMetricEntry]: NewMetricHelpers,
    [MetricType.SavedMetric]: SavedMetricRowHelpers,
    [MetricType.Funnel]: FunnelMetricRowHelpers,
    [MetricType.Retention]: RetentionMetricRowHelpers,
    [MetricType.RetentionFrequency]: RetentionMetricRowHelpers,
    [SelectorTypeDefinitions.FlowsEvent]: FlowsRowHelpers,
    [SelectorTypeDefinitions.Segment]: SegmentRowHelpers,
  };

  return (rowType && ENTRY_ROW_HELPERS[rowType]) ?? SuperRowHelpers;
}
